export default __webpack_public_path__ + "static/media/litho-templates-library-04.369d26c9.jpg";